import { BaseApiService } from "../base/base-api.service";
import { LegalEntitySIDTO } from "../../models/legal-entity-si";
import { LegalEntitySIsFilter } from "../../models/legal-entity-si";
import { LegalEntitySISTO } from "../../models/legal-entity-si";
import { SearchOptions } from "../../models/search-options/search-options";
import { Page } from "../../models/api/page";

import { toastifyResponse } from "../../utils/toastify-response/toastify-response";

export class LegalEntitySIsApiService extends BaseApiService<LegalEntitySIDTO, LegalEntitySISTO> {
  constructor() {
    super({
      servicePath: "/LegalEntitySIs",
      loadItemsPath: "/GetLegalEntitySIs",
      saveItemsPath: "/SaveLegalEntitySIs",
    });
  }
}

export const loadLegalEntitySIs = async (
  propsFilter: LegalEntitySIsFilter,
  searchOptions: SearchOptions,
  page: Page,
  signal?: AbortSignal
) => {
  const response = await new LegalEntitySIsApiService().loadItems(
    propsFilter,
    searchOptions.query,
    undefined,
    page,
    searchOptions.exactMatch,
    60,
    signal
  );

  toastifyResponse(response, "failed");

  return response;
};

export const saveLegalEntitySIs = async (legalEntitySI: LegalEntitySISTO) => {
  const response = await new LegalEntitySIsApiService().saveItems([legalEntitySI]);

  toastifyResponse(response, "failed");

  return response;
};
